import * as ko from "knockout";
import {IMessageData, ISearchMessage} from "../../index";
import page_messageHtml from './page-message.html?raw';

export let template: string = page_messageHtml;

export class viewModel {

    m: KnockoutObservable<IMessageData>;
    private _m: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private knockoutSubscription: KnockoutSubscription;
    private alertCssClass: string = "noMargin";
    private blockContainer: boolean;

    constructor(params: any) {
        this.m = params.messageData;
        this.blockContainer = !!params.blockContainer;

        if (params.alertCssClass === false) {
            this.alertCssClass = "";
        }
        if (params.alertCssClass) {
            this.alertCssClass = params.alertCssClass;
        }

        this.knockoutSubscription = this.m.subscribe((obj) => {
            if (!!obj) {
                obj.type = obj.type || "info";
                this._m(obj);
            }
        });

        if (this.m()) {
            this.m()!.type = this.m()!.type || "info";
            this._m(this.m());
        }
    }

    msg = ko.pureComputed(():ISearchMessage => {
        let ret:ISearchMessage = {
            icon: "",
            alert: "",
            message: ""
        };
        if (!!this._m()) {
            ret = {
                icon: this.getIconCssClasses(),
                alert: this.getAlertCssClasses(),
                message: this._m()!.message
            };
        }
        return ret;
    });

    private getIconCssClasses() {
        switch (this._m()?.type) {
            case "info":
                return 'fa-info-circle';
            case "danger":
                return 'fa-times-circle';
            case "warning":
                return 'fa-exclamation-triangle';
            case "success":
                return 'fa-check-circle';
        }
        return "";
    }

    private getAlertCssClasses() {
        let classes = ["alert", "alert-" + this._m()?.type, this.alertCssClass];
        return classes.join(" ");
    }

    doShow = ko.pureComputed((): boolean => {
        return !!this.m();
    });

    dispose() {
        this.knockoutSubscription.dispose();
    }
}
